import { GetAPI } from "../globalCallAPI";

export let fetchPendaftaranKategori = async (param: string | null) => {
    let s = await GetAPI(`front/statistik_kategori/pendaftaran?${param}`, {});
    return s;
};
export let fetchPenerbitanKategori = async (param: string | null) => {
    let s = await GetAPI(`front/statistik_kategori/penerbitan?${param}`, {});
    return s;
};

export let fetchPendaftaranJenis = async (param: string | null) => {
    let s = await GetAPI(`front/statistik_jenis_terbitan/pendaftaran?${param}`, {});
    return s;
};
export let fetchPenerbitanJenis = async (param: string | null) => {
    let s = await GetAPI(`front/statistik_jenis_terbitan/penerbitan?${param}`, {});
    return s;
};

export let fetchPendaftaranMedia = async (param: string | null) => {
    let s = await GetAPI(`front/statistik_media_terbitan/pendaftaran?${param}`, {});
    return s;
};
export let fetchPenerbitanMedia = async (param: string | null) => {
    let s = await GetAPI(`front/statistik_media_terbitan/penerbitan?${param}`, {});
    return s;
};

export let fetchPendaftaranTahunan = async () => {
    let s = await GetAPI(`front/statistik_tahunan/pendaftaran`, {});
    return s;
};
export let fetchPenerbitanTahunan = async () => {
    let s = await GetAPI(`front/statistik_tahunan/penerbitan`, {});
    return s;
};
export let fetchPenerbitanPerProvinsi = async (param: string | null) => {
    let s = await GetAPI(`front/statistik_provinsi/penerbitan?${param}`, {});
    return s;
};